import React, { useContext, useEffect, useRef, useState } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import { ConfigContext } from "../../Context/ConfigContext";
import { NoRecords } from "../../Components/Shimmer";
import { formatDate } from "../../Components/InputElements";
import { currentDateAndTime, decodeData } from '../../Constants/constants';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { useLocation } from "react-router-dom";

function EmployeeOnboard() {
    const { apiURL, apiHeaderFile, apiHeaderJSON,permissions } = useContext(ConfigContext);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const encodedData = queryParams.get("abs");
    const decodedData = encodedData ? decodeData(encodedData,permissions) : [];

    const [loading, setLoading] = useState(false);
    const [loadingDownload, setLoadingDownload] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [loadingImportExcel, setLoadingImportExcel] = useState(false);
    const [onboardingData, setOnboardingData] = useState([]);
    const [onboardingResponse, setOnboardingResponse] = useState({});
    const [isChange, setIsChange] = useState(false);
    const [allSheetChecked, setAllSheetChecked] = useState(false);
    const [successMsg, setSuccessMsg] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [allPages, setAllPages] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const fileInputRef = useRef(null);
    const [uploadSheets, setUploadSheet] = useState({
        file: null,
        remarks: "",
        basicDetails: false,
        educationDetails: false,
        salaryDetails: false,
        bankDetails: false,
        statutoryDetails: false,
        experienceDetails: false,
        familyDetails: false,
        documentDetails: false,
    });

    // const downloadButton = async (id, excelName) => {
    //     setLoadingDownload(id);
    //     try {
    //         const response = await fetch(`${apiURL}Employees/DownloadOnboardExcel/${id}`, {
    //             headers: apiHeaderJSON,
    //         });
    //         console.log("=======>>>>", response);
    //         // Check if the response is okay
    //         if (!response.ok) {
    //             throw new Error('Network response was not ok');
    //         }

    //         const blob = await response.blob();
    //         const url = window.URL.createObjectURL(blob);
    //         const link = document.createElement('a');
    //         link.href = url;
    //         link.setAttribute('download', `excel.xlsx`); // Filename for the downloaded file
    //         document.body.appendChild(link);
    //         link.click();
    //         document.body.removeChild(link);
    //         setSuccessMsg("Excel Downloaded Successfully!!");
    //         setLoadingDownload(false);
    //         // Clean up the URL object
    //         window.URL.revokeObjectURL(url);
    //     } catch (error) {
    //         console.error('Error exporting jobs:', error);
    //         setLoadingDownload(false);
    //         setErrorMsg("There was a problem with the download!! Please try again later.");
    //     }
    // }
    const downloadButton = async (id, excelName) => {
        setLoadingDownload(id);
        try {
            const response = await fetch(`${apiURL}Employees/DownloadOnboardExcel/${id}`, {
                headers: apiHeaderJSON,
            });

            // Check if the response is okay
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            // Extract the filename from the Content-Disposition header
            const contentDisposition = response.headers.get('Content-Disposition');
            let fileName = excelName || 'default.xlsx'; // Use provided excelName or default filename

            if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
                if (fileNameMatch && fileNameMatch[1]) {
                    fileName = fileNameMatch[1]; // Extract the filename
                }
            }

            // Create a blob and download the file
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName); // Use the extracted filename
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setSuccessMsg("Excel Downloaded Successfully!!");
            setLoadingDownload(false);

            // Clean up the URL object
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error exporting jobs:', error);
            setLoadingDownload(false);
            setErrorMsg("There was a problem with the download!! Please try again later.");
        }
    }


    const getEmployeeOnboardingData = () => {

        let options = {
            url: `${apiURL}Employees/GetEmployeeOnboardExcelFiles?limit=${limit}&page=${page}`,
            method: "GET",
            headers: apiHeaderJSON,
        }
        axios(options)
            .then((response) => {
                // console.log("getEmployeeOnboardingData ~ response", response?.data);
                let res = response?.data;
                if (response.data.success === true) {
                    // console.log("getEmployeeOnboardingData ~ res", res);
                    setOnboardingData(res?.data);
                    setOnboardingResponse(res);
                    setPage(res?.page);
                    setAllPages(res?.total_pages);
                    setTotalRecords(parseInt(res?.total_records));
                    // setSuccessMsg(response?.data?.message);
                }
                else if (response.data.success === false) {
                    setErrorMsg(response?.data?.message);
                }
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                console.log(e);
                setErrorMsg(e?.data?.message);

            });

    }
    useEffect(() => {
        setLoading(true);
        getEmployeeOnboardingData();
    },[]);

    const handleDeleteExcel = (id) => {
        const options = {
            url: `${apiURL}Employees/DeleteOnboardExcel/${id}`,
            method: "DELETE",
            headers: apiHeaderJSON,
        }
        Swal.fire({
            title: "Are you sure?",
            text: `If you delete this file, You won't able to revert this!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Delete!",
            cancelButtonText: "No, Cancel!",
            allowOutsideClick: false,
          }).then((result) => {
        if (result.isConfirmed) {
            setLoadingDelete(id);
            axios(options)
            .then((response) => {
                // console.log("getEmployeeOnboardingData ~ response", response?.data);
                let res = response?.data;
                if (response.data.success === true) {
                    console.log("handleDeleteExcel ~ res", res);
                    setSuccessMsg("Excel Deleted Successfully!!");
                    getEmployeeOnboardingData();
                }
                else if (response.data.success === false) {
                    setErrorMsg(response?.data?.message);
                }

                setLoadingDelete(false);
            })
            .catch((e) => {
                console.log(e);
                setErrorMsg(e?.data?.message);
                setLoadingDelete(false);
            });
            }
        })

    }

    // const handleExcelDownload = async () => {
    //     const headers = apiHeaderJSON;
    //     let data = {
    //         ...uploadSheets
    //     }
    //     Swal.fire({
    //         title: 'Please wait...',
    //         html: 'Your file is being prepared for download.',
    //         allowOutsideClick: false,
    //         didOpen: () => {
    //             Swal.showLoading();
    //         }
    //     });

    //     axios.post(`${apiURL}Payrolls/GetSalaryHeadTemplate`, data, {
    //         headers
    //     })
    //         .then(async (response) => {
    //             const { success, Onboarding_template, message } = response.data;

    //             if (success === true) {
    //                 // Create a new workbook
    //                 const workbook = XLSX.utils.book_new();

    //                 // Function to create worksheet for a category
    //                 const createWorksheet = (headerArray, sheetName) => {
    //                     let worksheetArray = [headerArray];
    //                     const worksheet = XLSX.utils.aoa_to_sheet(worksheetArray);
    //                     XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    //                 };
    //                 // Basic Details Sheet
    //                 if (Onboarding_template.basicDetailsTemplateArray) {

    //                     createWorksheet(Onboarding_template.basicDetailsTemplateArray, 'basicDetails');
    //                 }
    //                 // Education Details Sheet
    //                 if (Onboarding_template.educationDetailsTemplateArray) {

    //                     createWorksheet(Onboarding_template.educationDetailsTemplateArray, 'educationDetails');
    //                 }
    //                 // Salary Details Sheet
    //                 if (Onboarding_template.SalaryDetailsTemplateArray) {

    //                     createWorksheet(Onboarding_template.SalaryDetailsTemplateArray, 'salaryDetails');
    //                 }
    //                 // Salary Details Sheet
    //                 if (Onboarding_template.StatutoryDetailsTemplateArray) {

    //                     createWorksheet(Onboarding_template.StatutoryDetailsTemplateArray, 'StatutoryDetails');
    //                 }

    //                 const date = new Date();
    //                 const dateString = date.toLocaleDateString();
    //                 const timeString = date.toLocaleTimeString();
    //                 const file_name = `Employee Onboard Excel_(${formatDate(dateString)}).xlsx`;
    //                 // Write the workbook to an Excel file
    //                 XLSX.writeFile(workbook, file_name);
    //                 // XLSX.writeFile(wb, `Employee Onboard Excel_(${formatDate(dateString)}).xlsx`);

    //                 Swal.close();
    //                 Swal.fire({
    //                     title: `<strong>Success</strong>`,
    //                     text: message,
    //                     icon: 'success',
    //                     showConfirmButton: true
    //                 });
    //             } else {
    //                 Swal.close();
    //                 Swal.fire({
    //                     title: `<strong>Failed</strong>`,
    //                     text: message,
    //                     icon: 'error',
    //                     showConfirmButton: true
    //                 });
    //             }
    //         })
    //         .catch((error) => {
    //             Swal.close();
    //             Swal.fire({
    //                 title: `<strong>Failed</strong>`,
    //                 text: error.response ? error.response.message : error.message,
    //                 icon: 'error',
    //                 showConfirmButton: true
    //             });
    //         });
    // }
    const handleExcelDownload = async () => {
        const headers = apiHeaderJSON;
        let data = {
            ...uploadSheets,
            date: currentDateAndTime()
        }
        Swal.fire({
            title: 'Please wait...',
            html: 'Your file is being prepared for download.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        axios.post(`${apiURL}Payrolls/GetSalaryHeadTemplate`, data, {
            headers
        })
            .then(async (response) => {
                const { success, Onboarding_template, message } = response.data;

                if (success === true) {
                    // Create a new workbook
                    const workbook = XLSX.utils.book_new();

                    // Function to create worksheet for a category
                    const createWorksheet = (dataArray, sheetName) => {
                        let worksheetArray = [];

                        // If it's a 2D array, map each sub-array
                        if (Array.isArray(dataArray[0])) {
                            dataArray.forEach(subArray => {
                                worksheetArray.push(subArray);
                            });
                        } else {
                            // Otherwise, just use the single array
                            worksheetArray.push(dataArray);
                        }

                        const worksheet = XLSX.utils.aoa_to_sheet(worksheetArray);
                        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
                    };

                    // Basic Details Sheet
                    if (Onboarding_template.basicDetailsTemplateArray) {
                        createWorksheet(Onboarding_template.basicDetailsTemplateArray, 'BasicDetails');
                    }
                    // Education Details Sheet
                    if (Onboarding_template.educationDetailsTemplateArray) {
                        createWorksheet(Onboarding_template.educationDetailsTemplateArray, 'EducationDetails');
                    }
                    // Salary Details Sheet
                    if (Onboarding_template.SalaryDetailsTemplateArray) {
                        createWorksheet(Onboarding_template.SalaryDetailsTemplateArray, 'SalaryDetails');
                    }
                    // Statutory Details Sheet (handling 2D array case)
                    if (Onboarding_template.StatutoryDetailsTemplateArray) {
                        createWorksheet(Onboarding_template.StatutoryDetailsTemplateArray, 'StatutoryDetails');
                    }
                    // Bank Details Sheet 
                    if (Onboarding_template.BankDetailsTemplateArray) {
                        createWorksheet(Onboarding_template.BankDetailsTemplateArray, 'BankDetails');
                    }
                    // Experience Details Sheet 
                    if (Onboarding_template.ExperienceDetailsTemplateArray) {
                        createWorksheet(Onboarding_template.ExperienceDetailsTemplateArray, 'ExperienceDetails');
                    }
                    // Family Details Sheet 
                    if (Onboarding_template.FamilyDetailsTemplateArray) {
                        createWorksheet(Onboarding_template.FamilyDetailsTemplateArray, 'FamilyDetails');
                    }
                    // Document Details Sheet 
                    if (Onboarding_template.DocumentDetailsTemplateArray) {
                        createWorksheet(Onboarding_template.DocumentDetailsTemplateArray, 'DocumentDetails');
                    }

                    const file_name = `Employee Onboard Excel.xlsx`;

                    // Write the workbook to an Excel file
                    XLSX.writeFile(workbook, file_name);

                    Swal.close();
                    Swal.fire({
                        title: `<strong>Success</strong>`,
                        text: message,
                        icon: 'success',
                        showConfirmButton: true
                    });
                } else {
                    Swal.close();
                    Swal.fire({
                        title: `<strong>Failed</strong>`,
                        text: message,
                        icon: 'error',
                        showConfirmButton: true
                    });
                }
            })
            .catch((error) => {
                Swal.close();
                Swal.fire({
                    title: `<strong>Failed</strong>`,
                    text: error.response ? error.response.message : error.message,
                    icon: 'error',
                    showConfirmButton: true
                });
            });
    };


    function uploadEmployee() {
        setLoadingImportExcel(true);
        let data = {
            ...uploadSheets
        }
        let header = {
            // Accept: "application/json",
            ...apiHeaderFile,
        }
        // console.log("=====>>>", data);
        console.log("uploadEmployee ~ data", data);
        const options = {
            url: `${apiURL}Employees/ExcelImport`,
            method: "POST",
            headers: header,
            data: data,
        }
        axios(options)
            .then((response) => {
                console.log("=======>>>>>response", response);
                if (response?.data?.success === true) {
                    setSuccessMsg(response?.data?.message);
                    // setTimeout(() => {
                    //     setSuccessMsg(false);
                    // }, 5000);
                    getEmployeeOnboardingData();
                    setAllSheetChecked(false);
                    if (fileInputRef.current) {
                        fileInputRef.current.value = '';
                    }
                    setUploadSheet({
                        file: null,
                        remarks: "",
                        basicDetails: false,
                        educationDetails: false,
                        salaryDetails: false,
                        bankDetails: false,
                        statutoryDetails: false,
                        experienceDetails: false,
                        familyDetails: false,
                        documentDetails: false,
                    });
                }
                else if (response?.data?.success === false) {
                    setErrorMsg(response?.data?.message || "There is a problem to upload excel!!");
                    // setTimeout(() => {
                    //     setErrorMsg(false);
                    // }, 5000);
                }

                setLoadingImportExcel(false);
            })
            .catch((e) => {
                console.log(e);
                setLoadingImportExcel(false);
            });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (uploadSheets.file &&
            (uploadSheets?.bankDetails ||
            uploadSheets?.basicDetails ||
            uploadSheets?.documentDetails ||
            uploadSheets?.educationDetails ||
            uploadSheets?.experienceDetails ||
            uploadSheets?.familyDetails ||
            uploadSheets?.salaryDetails ||
            uploadSheets?.statutoryDetails)

        ) {
            uploadEmployee();

        }
        else if (
            !uploadSheets.file
        ) {
            setErrorMsg("Please select excel file to upload data.");
        } else if (
            !uploadSheets?.bankDetails &&
            !uploadSheets?.basicDetails &&
            !uploadSheets?.documentDetails &&
            !uploadSheets?.educationDetails &&
            !uploadSheets?.experienceDetails &&
            !uploadSheets?.familyDetails &&
            !uploadSheets?.salaryDetails &&
            !uploadSheets?.statutoryDetails
        ) {
            setErrorMsg("Please select atleast 1 sheet to upload data.");
        }
    }

    const handlePrev = () => {
        if (onboardingResponse?.prev === true && page > 1) {
            setPage(page - 1);
            setIsChange(true);
        }
    };
    const handleNext = () => {
        if (onboardingResponse?.next === true && allPages > page) {
            setPage(page + 1);
            setIsChange(true);
        }
    };


    const handleLimitChange = (e) => {
        setLimit(e.target.value);
        setIsChange(true);
    };

    useEffect(() => {
        if(isChange){
            getEmployeeOnboardingData();
            setIsChange(false);
        }
    }, [isChange])

    // console.log("success", successMsg);

    return (
        <section>
            {!loading ?
                <div class="main-content" >
                    <div class="page-content">
                        <div className="container-fluid">
                            <br />
                            <PageTitle title={`Employee Onboarding`} primary={`Home`} />

                            <div className="card">
                                <div className="card-body">
                                    { decodedData?.includes(6) && (
                                        <>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label >File Upload</label>
                                                    <div className="input-group">
                                                        <input ref={fileInputRef} type="file" onChange={(e) => { setUploadSheet({ ...uploadSheets, file: e.target.files[0] }) }} accept=".xlsx" className="form-control" name="fileUpload" aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="File Upload" />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <label >Remarks</label>
                                                    <div className="input-group">
                                                        <input type="text" value={uploadSheets?.remarks} onChange={(e) => { setUploadSheet({ ...uploadSheets, remarks: e.target.value }) }} className="form-control" name="remarks" aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Remarks" />

                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label>Upload</label>
                                                    <div>
                                                        {!loadingImportExcel ?
                                                            <button type="button" onClick={(e) => handleSubmit(e)} className={`btn btn-info btn-label waves-effect waves-light w-100 ${uploadSheets?.file ? "" : "disabled"}`}>
                                                                <i className="bx bx-cloud-upload label-icon align-middle fs-16 me-2" />Upload
                                                            </button> :
                                                            <button type="button" className={`btn btn-info btn-label waves-effect waves-light w-100`}>
                                                                <i className="bx bx-cloud-upload label-icon align-middle fs-16 me-2" />Loading...
                                                            </button>
                                                        }
                                                    </div>
                                                </div>
                                                <div style={{ width: "15%" }} className='col-md-2'>
                                                    <div>
                                                        <label>Export Template</label>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        onClick={handleExcelDownload}
                                                        disabled={loading}
                                                        className={`${(!uploadSheets?.bankDetails
                                                            && !uploadSheets?.basicDetails
                                                            && !uploadSheets?.documentDetails
                                                            && !uploadSheets?.educationDetails
                                                            && !uploadSheets?.experienceDetails
                                                            && !uploadSheets?.familyDetails
                                                            && !uploadSheets?.salaryDetails
                                                            && !uploadSheets?.statutoryDetails)
                                                            ? 'disabled' : ''} btn noWrap btn-success btn-label waves-effect waves-light noWrap`}>
                                                        <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                                        {!loading ? "Download" : "Loading..."}
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <label htmlFor="keyword">Selected sheet will be uploaded or Exported</label>
                                                <div>
                                                    <div onClick={(e) => {
                                                        setAllSheetChecked(!allSheetChecked);
                                                        setUploadSheet({
                                                            ...uploadSheets,
                                                            basicDetails: !allSheetChecked,
                                                            educationDetails: !allSheetChecked,
                                                            salaryDetails: !allSheetChecked,
                                                            bankDetails: !allSheetChecked,
                                                            statutoryDetails: !allSheetChecked,
                                                            experienceDetails: !allSheetChecked,
                                                            familyDetails: !allSheetChecked,
                                                            documentDetails: !allSheetChecked,
                                                        });
                                                        setErrorMsg(false);
                                                    }} style={{ width: "fit-content" }} className="form-check">
                                                        <input checked={allSheetChecked} className="form-check-input" type="checkbox" name="chk_child" defaultValue="option1" />
                                                        <label htmlFor="keyword">Select All</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div style={{ width: "fit-content" }} onClick={(e) => { setUploadSheet({ ...uploadSheets, basicDetails: !uploadSheets?.basicDetails }); setErrorMsg(false); }} className="form-check">
                                                        <input checked={uploadSheets?.basicDetails} className="form-check-input" type="checkbox" name="chk_child" defaultValue="option1" />
                                                        <label htmlFor="keyword">BasicDetails</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div style={{ width: "fit-content" }} onClick={(e) => { setUploadSheet({ ...uploadSheets, educationDetails: !uploadSheets?.educationDetails }); setErrorMsg(false); }} className="form-check">
                                                        <input checked={uploadSheets?.educationDetails} className="form-check-input" type="checkbox" name="chk_child" defaultValue="option1" />
                                                        <label htmlFor="keyword">EducationDetails</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div style={{ width: "fit-content" }} onClick={(e) => { setUploadSheet({ ...uploadSheets, salaryDetails: !uploadSheets?.salaryDetails }); setErrorMsg(false); }} className="form-check">
                                                        <input checked={uploadSheets?.salaryDetails} className="form-check-input" type="checkbox" name="chk_child" defaultValue="option1" />
                                                        <label htmlFor="keyword">SalaryDetails</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div style={{ width: "fit-content" }} onClick={(e) => { setUploadSheet({ ...uploadSheets, bankDetails: !uploadSheets?.bankDetails }); setErrorMsg(false); }} className="form-check">
                                                        <input checked={uploadSheets?.bankDetails} className="form-check-input" type="checkbox" name="chk_child" defaultValue="option1" />
                                                        <label htmlFor="keyword">BankDetails</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div style={{ width: "fit-content" }} onClick={(e) => { setUploadSheet({ ...uploadSheets, statutoryDetails: !uploadSheets?.statutoryDetails }); setErrorMsg(false); }} className="form-check">
                                                        <input checked={uploadSheets?.statutoryDetails} className="form-check-input" type="checkbox" name="chk_child" defaultValue="option1" />
                                                        <label htmlFor="keyword">StatutoryDetails</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div style={{ width: "fit-content" }} onClick={(e) => { setUploadSheet({ ...uploadSheets, experienceDetails: !uploadSheets?.experienceDetails }); setErrorMsg(false); }} className="form-check">
                                                        <input checked={uploadSheets?.experienceDetails} className="form-check-input" type="checkbox" name="chk_child" defaultValue="option1" />
                                                        <label htmlFor="keyword">ExperienceDetails</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div style={{ width: "fit-content" }} onClick={(e) => { setUploadSheet({ ...uploadSheets, familyDetails: !uploadSheets?.familyDetails }); setErrorMsg(false); }} className="form-check">
                                                        <input checked={uploadSheets?.familyDetails} className="form-check-input" type="checkbox" name="chk_child" defaultValue="option1" />
                                                        <label htmlFor="keyword">FamilyDetails</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div style={{ width: "fit-content" }} onClick={(e) => { setUploadSheet({ ...uploadSheets, documentDetails: !uploadSheets?.documentDetails }); setErrorMsg(false); }} className="form-check">
                                                        <input checked={uploadSheets?.documentDetails} className="form-check-input" type="checkbox" name="chk_child" defaultValue="option1" />
                                                        <label htmlFor="keyword">DocumentDetails</label>
                                                    </div>
                                                </div>

                                            </div>
                                            {successMsg ?
                                            <div className=" position-relative alert alert-success mt-3" role="alert">
                                                {successMsg} <span onClick={() => { setSuccessMsg(false) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                            </div>
                                            : null
                                            }
                                            {errorMsg ?
                                                <div className=" position-relative alert alert-danger mt-3" role="alert">
                                                    {errorMsg} <span onClick={() => { setErrorMsg(false) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                                </div> : null
                                            }
                                        </>
                                    )}
                                    <div id="example_wrapper" className="dataTables_wrapper dt-bootstrap5 no-footer mt-4">
                                        <div className="row">
                                            <div className="col-sm-12 col-md-6">
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div style={{ "maxHeight": "65vh", "overflowY": "auto" }} className="col-sm-12">
                                                <table id="example" className="table table-bordered dt-responsive nowrap table-striped align-middle dataTable no-footer dtr-inline collapsed table-hover" style={{ width: '100%' }} aria-describedby="example_info">
                                                    <thead class="bg-primary text-light bg-gradient sticky-top z-1">
                                                        <tr>
                                                            <th >ID</th>
                                                            <th className="noWrap">Upload Date</th>
                                                            <th >File Name</th>
                                                            <th >Remarks</th>
                                                            { decodedData?.includes(4) && (<th className=' text-center'>Action</th>)}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Array.isArray(onboardingData) && onboardingData?.length >= 1 ?
                                                            <>
                                                                {onboardingData?.map((val, index) => {
                                                                    return (
                                                                        <>
                                                                            <tr key={val?.id} className="odd">
                                                                                <td>{index + 1}</td>
                                                                                {/* <td>{formatDate(val?.updated_date)}  </td> */}
                                                                                <td className="noWrap">{val?.updated_date ? formatDate(val?.updated_date):"--"} </td>
                                                                                <td onClick={(e) => {
                                                                                    downloadButton(val?.id, val?.file_name?.split("/")[val?.file_name?.split("/").length - 1])
                                                                                }}
                                                                                    className="" >
                                                                                    {loadingDownload === val?.id ?
                                                                                        <div className="text-center">
                                                                                            <div className="spinner-border text-primary" role="status">
                                                                                                <span className="visually-hidden">Loading...</span>
                                                                                            </div>
                                                                                        </div> :
                                                                                        <p className=" hoverBlue cursorPointer">{val?.file_name?.split("/")[val?.file_name?.split("/").length - 1]}</p>
                                                                                    }
                                                                                </td>
                                                                                <td>{val?.remarks}</td>
                                                                                { decodedData?.includes(4) && (
                                                                                <td className=' text-center'>
                                                                                    {loadingDelete === val?.id ?
                                                                                        <button
                                                                                            type="button" class="btn btn-danger bg-danger text-light F "
                                                                                        >Loading...</button> :
                                                                                        <button
                                                                                            onClick={() => { handleDeleteExcel(val?.id) }} type="button" class="btn btn-danger bg-danger text-light waves-effect "
                                                                                        >Delete</button>
                                                                                    }
                                                                                </td>)}
                                                                            </tr>
                                                                        </>
                                                                    )
                                                                })

                                                                }

                                                            </>
                                                            :
                                                            <td colSpan={5}>
                                                                <NoRecords />
                                                            </td>
                                                        }


                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between w-100 p-2" >
                                            <button disabled={onboardingResponse?.prev === false && loading === false}
                                                type="button" onClick={handlePrev} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                            <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                {
                                                    <small>Total Records: {totalRecords} | Total Pages: {allPages} | Current Page: {page}</small>
                                                }
                                            </div>
                                            <div className='col-md-2'>
                                                <select className="form-select">
                                                    <option value="1">Page 1</option>
                                                </select>
                                            </div>
                                            <div className="col-md-2">
                                                <select onChange={(e) => { handleLimitChange(e) }} className="form-select" >
                                                    <option value="10">Limit 10</option>
                                                    <option value="25">Limit 25</option>
                                                    <option value="50">Limit 50</option>
                                                    <option value="100">Limit 100</option>
                                                    <option value="200">Limit 200</option>
                                                    <option value="500">Limit 500</option>
                                                    {totalRecords > 500 ?
                                                        <option value={`${totalRecords}`}>Limit {totalRecords}</option> : null}
                                                </select>
                                            </div>
                                            <button onClick={handleNext} disabled={onboardingResponse?.next === false && loading === false}
                                                type="button" className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> :
                <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>

            }
        </section >
    );
}

export default EmployeeOnboard;